import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fetchProducts = (params = {}) =>
  axios.get(`${API}/products`, { params }).then((r) => r.data);

export const submitEnquiry = (payload) =>
  axios.post(`${API}/enquiries`, payload).then((r) => r.data);

export const adminLogin = (email, password) =>
  axios.post(`${API}/auth/login`, { email, password }).then((r) => r.data);

export const fetchEnquiries = (token, status = "all") =>
  axios
    .get(`${API}/admin/enquiries`, {
      params: { status },
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((r) => r.data);

export const updateEnquiryStatus = (token, id, status) =>
  axios
    .patch(
      `${API}/admin/enquiries/${id}`,
      { status },
      { headers: { Authorization: `Bearer ${token}` } }
    )
    .then((r) => r.data);

export function formatApiError(error, fallback = "Something went wrong. Please try again.") {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").filter(Boolean).join(" ");
  return fallback;
}
